import TrialPeriod from './trial-period.interface';
import { TrialPeriodService } from './trial-period.service';
const service = new TrialPeriodService();

export interface TrialPeriodState {
   trialPeriods: Array<TrialPeriod>;
}

const state: TrialPeriodState = {
   trialPeriods: [],
};

const getters = {
   trialPeriods(state: any) {
      return state.trialPeriods;
   },
};

const mutations = {
   setTrialPeriods(state: any, newValue: any) {
      state.trialPeriods = newValue;
   },
};

const actions = {
   async getTrialPeriods(context: any) {
      return await service.getTrialPeriods().then((response) => {
         context.commit('setTrialPeriods', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
